import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  FormGroup,
  Button,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { titleCase } from "../../utils/case";
import { LANGS, emptyLang } from "../../utils/pageHelpers";
import { hasRole } from "../../utils/auth";

const LangInput = ({
  t,
  content,
  field,
  label,
  type = "text",
  updateLangField,
  disabled
}) => (
  <Card className="mb-4">
    <CardBody>
      <h6>{titleCase(t(label))}</h6>

      <Row>
        {LANGS.map((lang) => (
          <Col md="4" key={lang}>
            <FormGroup>
              <Label>{lang.toUpperCase()}</Label>

              <Input
                type={type}
                rows={type === "textarea" ? 4 : undefined}
                value={content[field]?.[lang] || ""}
                onChange={(e) =>
                  updateLangField(field, lang, e.target.value)
                }
                disabled={disabled}
              />
            </FormGroup>
          </Col>
        ))}
      </Row>
    </CardBody>
  </Card>
);

const ArrayLangInput = ({
  t,
  content,
  arrayField,
  index,
  field,
  label,
  type = "text",
  updateArrayLangField,
  disabled
}) => (
  <Row>
    {LANGS.map((lang) => (
      <Col md="4" key={lang}>
        <FormGroup>
          <Label>
            {titleCase(t(label))} - {lang.toUpperCase()}
          </Label>

          <Input
            type={type}
            rows={type === "textarea" ? 3 : undefined}
            value={
              content[arrayField]?.[index]?.[field]?.[lang] || ""
            }
            onChange={(e) =>
              updateArrayLangField(
                arrayField,
                index,
                field,
                lang,
                e.target.value
              )
            }
            disabled={disabled}
          />
        </FormGroup>
      </Col>
    ))}
  </Row>
);

const Policy = ({
  content,
  updateLangField,
  updateArrayLangField,
  addArrayItem,
  removeArrayItem,
}) => {
  const { t } = useTranslation();
  const canManage = hasRole(
    "superadmin",
    "finance"
  );

  return (
    <>
      <LangInput
        t={t}
        content={content}
        field="introHeading"
        label="intro heading"
        updateLangField={updateLangField}
        disabled={!canManage}
      />

      <LangInput
        t={t}
        content={content}
        field="introParagraph"
        label="intro paragraph"
        type="textarea"
        updateLangField={updateLangField}
        disabled={!canManage}
      />

      <Card className="mb-4">
        <CardBody>
          <div className="d-flex justify-content-between mb-3">
            <h6>{titleCase(t("items"))}</h6>

            {canManage && (
              <Button
                size="sm"
                color="primary"
                onClick={() =>
                  addArrayItem("items", {
                    title: emptyLang(),
                    description: emptyLang(),
                  })
                }
              >
                {titleCase(t("add item"))}
              </Button>
            )}
          </div>

          {(content.items || []).map((item, index) => (
            <Card className="mb-3" key={index}>
              <CardBody>
                <div className="d-flex justify-content-end mb-2">
                  {canManage && (
                    <Button
                      size="sm"
                      color="danger"
                      outline
                      onClick={() => removeArrayItem("items", index)}
                    >
                      {titleCase(t("remove"))}
                    </Button>
                  )}
                </div>

                <ArrayLangInput
                  t={t}
                  content={content}
                  arrayField="items"
                  index={index}
                  field="title"
                  label="title"
                  updateArrayLangField={updateArrayLangField}
                  disabled={!canManage}
                />

                <ArrayLangInput
                  t={t}
                  content={content}
                  arrayField="items"
                  index={index}
                  field="description"
                  label="description"
                  type="textarea"
                  updateArrayLangField={updateArrayLangField}
                  disabled={!canManage}
                />
              </CardBody>
            </Card>
          ))}
        </CardBody>
      </Card>
    </>
  );
};

export default Policy;